/*
 * @Author: chenchaoqiang@leedarson.com
 * @Date: 2022-08-09 09:19:47
 * Copyright 2022 Leedarson, All Rights Reserved.
 */
const getQueryString = (name: string) => {
  const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`, 'i');
  const r = window.location.search.substr(1).match(reg);
  if (r != null) return unescape(r[2]);
  return null;
};

export { getQueryString };
